const FixedText = ({ label, text, textColSpan }) => {
  return (
    <>
      <p className="justify-self-end">{label}</p>
      <p className={`${textColSpan}`}>{text}</p>
    </>
  );
};

export default FixedText;
